<template>
  <div :key="model.Codigo">
    <b-card class="mb-3 mt-3">
      <core-Form ref="form">
        <b-form-row>
          <b-form-group label="Banco" class="col-3">
            <input-select
              v-model="model.banco"
              :input="changeBanco"
              :options="bancos"
              required
            />
          </b-form-group>

          <b-form-group label="Agência" class="col-3">
            <input-select
              v-model="model.agencia"
              :input="changeAgencia"
              :options="agencias"
              required
            />
          </b-form-group>

          <b-form-group label="Conta" class="col-3">
            <input-select
              v-model="model.conta"
              :input="changeConta"
              :search="pesquisaConta"
              :options="contas"
              :disabled="!model.agencia"
              required
            />
          </b-form-group>

          <b-form-group label="Modelo Conta" class="col-3">
            <b-form-select
              v-model="model.modeloConta"
              :options="$api.Arrays.ModeloConta"
              disabled
            />
          </b-form-group>
        </b-form-row>

        <b-form-row>
          <b-form-group label="Cliente" class="col-6">
            <b-input v-model="model.nome" disabled />
          </b-form-group>

          <b-form-group label="Documento Federal" class="col-3">
            <input-documento v-model="model.documentoFederal" disabled />
          </b-form-group>

          <b-form-group label="Tipo Pessoa" class="col-3">
            <b-form-select
              v-model="model.tipoPessoa"
              :options="$api.Arrays.TiposPessoa"
              disabled
            />
          </b-form-group>
        </b-form-row>

        <b-form-row>
          <slot name="extraBtns"></slot>
        </b-form-row>
      </core-Form>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bancos: [],
      agencias: [],
      contas: [],
      firstLoadSelected: true,
    };
  },
  props: {
    value: Object,
    codigoAgenciaSelected: String,
    codigoContaSelected: String,
    numeroContaSelected: String
  },
  computed: {
    model: {
      get() {
        var obj = this.value;
        return obj;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    codigoContaSelected(val) {
      let th = this;
      if (val && th.codigoAgenciaSelected) {
        th.firstLoadSelected = true;
        th.model.agencia = th.agencias.find(
          (a) => a.value === th.codigoAgenciaSelected
        );
        th.changeAgencia(th.model.agencia);
      }
    },
  },
  created() {
    this.pesquisaConta = _.debounce(this.loadComboContas, 300);
  },
  methods: {
    validate() {
      return this.$api.UI.FormValidate(this.$refs.form);
    },
    loadComboBancos() {
      let th = this;
      th.$api.Bancos.GetBancosInternos().then((data) => {
        if (Array.isArray(data)) {
          data.forEach((item) => {
            let banco = {
              value: item.codigo,
              text: item.numero + " - " + item.descricao,
            };
            th.bancos.push(banco);
            if (item.numero === process.env.VUE_APP_BANCO) {
              th.model.banco = banco;
            }
          });

          th.changeBanco(th.model.banco);
        }
      });
    },
    loadComboContas(conta) {
      let th = this;
      th.contas = [];

      if (
        th.model.agencia &&
        th.model.agencia.value
      ) {
        if (th.firstLoadSelected && th.numeroContaSelected)
          conta = th.numeroContaSelected;

        let dto = {
          parameters: [
            { name: "codigoAgencia", value: th.model.agencia.value },
            { name: "numeroConta", value: conta },
          ],
        };

        th.$api.Contas.ComboContas(dto).then((data) => {
          if (data) {
            if (!data.length || data.length === 0) {
              th.$api.UI.ShowError(
                "Erro",
                "Não foram encontradas contas com os parâmetros informados."
              );
            } else {
              data.forEach((item) => {
                th.contas.push({
                  value: item.codigo,
                  text: item.contaPgto,
                  contaPgto: th.$api.UI.Format.ContaPgto(item.contaPgto),
                  descricao: item.descricao,
                  tipoConta: item.tipoConta,
                  numero: item.numero,
                  digito: item.digito,
                });
              });
              if (th.codigoContaSelected && th.firstLoadSelected) {
                th.model.conta = th.contas.find(
                  (e) => e.value === th.codigoContaSelected
                );
                th.changeConta(th.model.conta);
                th.firstLoadSelected = false;
              }
            }
          }
        });
      }
    },
    changeBanco() {
      let th = this;
      let val = th.model.banco;

      if (!val) return;

      th.agencias = [];
      th.model.agencia = null;
      th.changeAgencia(null);

      if (val) {
        th.model.codigoBanco = val.value;
        let dto = {
          parameters: [{ name: "codigoBanco", value: val.value }],
        };
        th.$api.Agencias.GetAll(dto)
          .then((data) => {
            if (data) {
              if (!data.length || data.length === 0) {
                th.$api.UI.ShowError(
                  "Erro",
                  "Não existem agências cadastradas para este banco."
                );
              } else {
                data.forEach((item) => {
                  th.agencias.push({
                    value: item.codigo,
                    text: item.numero + "-" + item.digito + " " + item.nome,
                    numero: item.numero,
                    digito: item.digito,
                  });
                });
              }
            }
          })
          .then(() => {
            th.$api.Agencias.GetCodigoAgenciaPadrao().then((data) => {
              if (data && data.length > 0) {
                var agenciaPadrao = th.agencias.find((ag) => {
                  return ag.value === data;
                });
                if (agenciaPadrao !== undefined) {
                  th.model.agencia = agenciaPadrao;
                  th.changeAgencia(agenciaPadrao);
                }
              }
            });
          });
      }
    },
    changeAgencia(val) {
      let th = this;
      th.model.conta = null;
      th.contas = [];

      if (val) {
        th.model.codigoAgencia = val.value;
        th.model.agenciaPagador = val.text;
      }

      th.$nextTick(() => {
        th.loadComboContas();
      });
    },
    changeConta(val) {
      let th = this;
      th.model.nome = "";
      th.model.documentoFederal = "";
      th.model.tipoPessoa = null;
      th.model.modeloConta = null;

      if (val) {
        th.model.codigoConta = val.value;
        th.model.contaPagador = val.text;

        let dto = {
          parameters: [{ name: "codigoConta", value: val.value }],
        };

        th.$api.Parceiros.GetParceiroPorConta(th.model.codigoConta).then(
          (data) => {
            th.model.parceiroNome = data.parceiroNome;
          }
        );

        th.$api.ContaCorrentistas.GetAll(dto).then((data) => {
          if (Array.isArray(data)) {
            data.forEach((item) => {
              if (item.titularidade === 1) {
                th.model.nome = item.nome;
                th.model.details = item;
                th.model.documentoFederal = th.$api.UI.Format.DocumentoFederal(
                  item.documentoFederal
                );
                th.model.tipoPessoa = item.tipoPessoa;
                th.model.modeloConta = item.modeloConta;
                th.model = Object.assign({}, th.model);
              }
            });
          }
        });
      }
    },
  },
  beforeMount() {
    this.loadComboBancos();
  },
};
</script>
